export default "__VITE_ASSET__rCTpTVpQ__"